import React from 'react'
import {useNavigate} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {useLanguage} from '../../../_gori/i18n/Metronici18n'
import LanguageToggle from '../../modules/common/components/LanguageToggle'
import {SeoHead} from '../../modules/seo'

const DemoIntroVideoPage: React.FC = () => {
  const navigate = useNavigate()
  const intl = useIntl()
  const {language} = useLanguage()

  const getVideoUrl = () => {
    const baseUrl = 'https://gori-ai.s3.us-west-2.amazonaws.com/shipbae-assets/demo-videos'
    let langCode = 'en'

    if (language === 'ja') {
      langCode = 'ja'
    } else if (language === 'zh') {
      langCode = 'zh'
    }

    return `${baseUrl}/${langCode}/a1/what_is_a1.mp4`
  }

  const handleSkip = () => {
    navigate('/demo/topics')
  }

  const handleVideoEnd = () => {
    navigate('/demo/topics')
  }

  return (
    <div className='demo-intro-container'>
      <SeoHead />
      <img
        src='/media/logos/shipbae-gori-logo-black.svg'
        alt='ShipBae Powered By Gori.ai'
        className='img-fluid demo-intro-logo'
      />

      <video
        key={language}
        controls
        className='img-fluid demo-intro-video'
        onEnded={handleVideoEnd}
      >
        <source src={getVideoUrl()} type='video/mp4' />
        Your browser does not support the video tag.
      </video>

      <div className='demo-intro-controls'>
        <button onClick={handleSkip} className='btn text-white demo-intro-skip-btn'>
          {intl.formatMessage({id: 'DEMO_INTRO_SKIP_BUTTON'})}
        </button>
      </div>

      <LanguageToggle />
    </div>
  )
}

export default DemoIntroVideoPage
